<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const MEDIA_TYPES = [
  { value: 'none', label: t('site.f.content_section.opt_none', 'None') },
  { value: 'image', label: t('site.f.content_section.opt_image', 'Image') },
  { value: 'youtube', label: t('site.f.content_section.opt_youtube', 'YouTube') }
] as const

const LAYOUTS = [
  { value: 'left', label: t('site.f.content_section.opt_media_left', 'Media left') },
  { value: 'right', label: t('site.f.content_section.opt_media_right', 'Media right') },
  { value: 'full', label: t('site.f.content_section.opt_full_width', 'Full width') }
] as const

const setMediaType = (value: string | number) => {
  props.block.data.media_type = value === 'none' ? null : (value as 'image' | 'youtube')
  props.block.data.media_url = ''
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.title_label', 'Title')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.content_section.detail', 'Detail')">
    <UTextarea
      v-model="block.data.subtext"
      :rows="4"
      class="w-full"
    />
  </UFormField>

  <UFormField :label="t('site.f.content_section.media', 'Media')">
    <SiteEditorOptionToggle
      :options="MEDIA_TYPES"
      :model-value="block.data.media_type ?? 'none'"
      @update:model-value="setMediaType"
    />
  </UFormField>

  <template v-if="block.data.media_type === 'image'">
    <UFormField :label="t('site.f.common.image_label', 'Image')">
      <SiteEditorImagePicker
        variant="wide"
        :model-value="block.data.media_url"
        @update:model-value="block.data.media_url = $event"
      />
    </UFormField>
    <UFormField :label="t('site.f.content_section.link', 'Link (optional)')" :help="t('site.f.content_section.wraps_the_image_so_visitors_can_click_th_help', 'Wraps the image so visitors can click through.')">
      <UInput
        v-model="block.data.media_link"
        :placeholder="t('site.f.common.url_placeholder', 'https://...')"
        class="w-full"
      />
    </UFormField>
  </template>

  <UFormField
    v-else-if="block.data.media_type === 'youtube'"
    :label="t('site.f.content_section.youtube_url', 'YouTube URL')"
  >
    <UInput
      v-model="block.data.media_url"
      :placeholder="t('site.f.content_section.https_www_youtube_com_watch_v', 'https://www.youtube.com/watch?v=...')"
      class="w-full"
    />
  </UFormField>

  <UFormField
    v-if="block.data.media_type"
    :label="t('site.f.common.layout_label', 'Layout')"
  >
    <SiteEditorOptionToggle
      :options="LAYOUTS"
      :model-value="block.data.layout ?? 'right'"
      @update:model-value="block.data.layout = $event as 'left' | 'right' | 'full'"
    />
  </UFormField>
</template>
